<template>
	<div class="stroeGoods">
  
		<div >
		<Qrcode-Dialog :openQueHuochuankao.sync="openQueHuochuankao"  :storeData='storeData'  @createPurOrder="tocaiguo"/>
		<Qrcode-Dialog :sluginreminder.sync="sluginreminder" :storeData='storeData' />
		<Qrcode-Dialog :showSales.sync="showSales" :salesItem="salesItem"/>
		<Qrcode-Dialog :instockdia.sync="instockdia" :maincusCode="maincusCode"/>
		<Table-Dialog  :showTable.sync="showTable" @getShopItem="getShopItem" @giveItem="giveItem"></Table-Dialog>
		<Table-Dialog  :bindInfo.sync="bindInfo"  :p_sku_Info="p_sku_Info"></Table-Dialog>
		<Table-Dialog  :parentSkuDia.sync="parentSkuDia" :paramsCopy="paramsCopy" @reFresh="reFresh"></Table-Dialog>
		<Table-Dialog  :createProduct.sync="createProduct" ></Table-Dialog>
		 <Table-Dialog  :openDialog.sync="openDialog"  :TitleDesc="TitleDesc"  @createItemNotProduct="createItemNotProduct"></Table-Dialog>
		<el-dialog
		:title="qty"
		:visible.sync="errorDia"
		width="60%"
		>
		<el-table :data="listErrorOptions" :show-header="false" height="350px" >
			<el-table-column  label="cusCode" >
			<template slot-scope="scope">
				<span style="color:red">{{$t('other.a3025')}}{{scope.row.cusCode}}{{$t('other.a2436')}}{{$t('other.a677')}}：{{scope.row.desc}}</span>
			</template>
			</el-table-column>
		</el-table>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="errorDia = false">{{$t('other.a1552')}}</el-button>
			
		</span>
		</el-dialog>
		<!-- 产品转移 -->
		<el-dialog
		:title="$t('other.a2618')"
		:visible.sync="transproductDia"
		width="30%"
		>
		<el-select v-model="targetStoreid" :placeholder="$t('other.a2619')" >
			<el-option v-for="item in warehouseOption" :key="item.storeId" :label="item.label" :value="item.value">
			</el-option>
		</el-select>
		<span slot="footer" class="dialog-footer">
			<el-button size='small' type="primary" @click="transproductDia = false">{{$t('other.a106')}}</el-button>
			<el-button size='small' type="primary" @click="transformPorduct()">{{$t('other.a274')}}</el-button>
		</span>
		</el-dialog>
		<!-- 录入产品条形码 -->
		<el-dialog
		:title="$t('other.a3069')"
		:visible.sync="productCode"
		width="60%"
		>
		<el-input v-model="barCode" :placeholder="$t('other.a3070')"></el-input>
		<span slot="footer" class="dialog-footer">
			<el-button size="small" type="primary" @click="productCode = false">{{$t('other.a106')}}</el-button>
			<el-button size="small" type="primary" @click="submitCoding()">{{$t('other.a274')}}</el-button>
		</span>
		</el-dialog>
		<el-dialog
		:title="$t('other.a3026')"
		:visible.sync="updatPic"
		width="40%"
		>
		<div>
			<el-upload
			class="upload-demo "
			action="https://erp.shopsbu.com/service/access/upload"
			:on-success="handlePreview"
			:headers="token"
			:file-list="fileList2"
			:limit="1"
			list-type="picture">
			<el-button ref="filElem" size="small" type="primary">{{$t('other.a368')}}</el-button>
			<div slot="tip" class="el-upload__tip">{{$t('other.a3027')}}</div>
			</el-upload>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="updatPic = false">{{$t('other.a106')}}</el-button>
			<el-button type="primary" @click="imgConfirm">{{$t('other.a279')}}</el-button>
		</span>
		</el-dialog>
		<!-- 绑定商品信息 -->
		<el-dialog :title="$t('userStoreItems').bindItem.title" :visible.sync="dialogTableVisible" width="80%">
			<div class="xinzhen"><el-button size="medium" type="primary" @click="goBindproduct">{{$t('userStoreItems').bindItem.xinzhen}}</el-button></div>
			<el-table :data="bindItemList01" height="500px" >
				<el-table-column width="80" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<el-popover placement="top-start" title="" trigger="hover">
							<img :src="changeImgURL(scope.row)" alt="" style="width: 150px;height: 150px">
							<img slot="reference" :src="changeImgURL(scope.row)" style="width: 30px;height: 30px">
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column  :label="$t('userStoreItems').bindItem.shopName"  :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<span>{{scope.row.shopName}} ({{platform(scope.row.shopee)}})</span>
					</template>
				</el-table-column>
				<el-table-column property="name" :label="$t('userStoreItems').bindItem.anthreName"  :show-overflow-tooltip="true"></el-table-column>
				<el-table-column property="itemSku" label="sku"  :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<span>{{conversionSku(scope.row)}}</span>
					</template>
				</el-table-column>
				<el-table-column property="itemSku" :label="$t('other.a190')"  :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<span>{{ scope.row.isPreOrder ? $t('other.a191') : $t('other.a192')}}</span>
					</template>
				</el-table-column>
				<el-table-column  :label="$t('other.a3006')" width="200px"  :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<el-switch
						v-show="scope.row.shopee"
						@change='autoPre(scope.row)'
						v-model="scope.row.isAutoPre"
						:active-text="$t('other.a191')"
						:inactive-text="$t('other.a192')">
						</el-switch>
					</template>
				</el-table-column>
				<el-table-column   :label="$t('other.a2920') width="200px"  >
					<template slot-scope="scope">
						<span v-show="!scope.row.setPresale">{{scope.row.preDay}}</span>
						<el-input v-if="scope.row.setPresale" style="width: 80px;" size="mini"   v-model="scope.row.preDay" ></el-input>
						<i v-show="!scope.row.setPresale && scope.row.isAutoPre" class="el-icon-edit" @click="scope.row.setPresale=true"></i>
						<span style="margin-left: 12px;cursor: pointer;color: red;" v-show="scope.row.setPresale" @click="fixPresale(scope.row)">{{$t('other.a38')}}</span>
					</template>
				</el-table-column>
				<!-- <el-table-column  :label="$t('other.a2456')" width="200px"  >
					<template slot-scope="scope">
						<span v-show="!scope.row.setRate">{{scope.row.hasVariation ? scope.row.variation.rate :scope.row.rate}}</span>
						<el-input-number v-if="scope.row.setRate && scope.row.hasVariation" style="width: 120px;" size="mini" :min="1"  v-model="scope.row.variation.rate" ></el-input-number>
						<el-input-number v-if="scope.row.setRate && !scope.row.hasVariation" style="width: 120px;" size="mini" :min="1"  v-model="scope.row.rate" ></el-input-number>
						<i v-show="!scope.row.setRate" class="el-icon-edit" @click="scope.row.setRate=true"></i>
						<span style="margin-left: 12px;cursor: pointer;color: red;" v-show="scope.row.setRate" @click="fixRate(scope.row)">{{$t('other.a38')}}</span>
					</template>
				</el-table-column> -->
				<el-table-column  :label="$t('userStoreItems').bindItem.operate"  :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<el-button type="danger" @click="jiebang(scope.row)">{{$t('userStoreItems').bindItem.jieban}}</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>
		<!-- 所属套餐 -->
		<el-dialog :title="$t('other.a3072')" :visible.sync="dialogTableVisibleTwo" width="80%">
			<div style="text-align:right;font-size:18px;margin-bottom:20px">{{$t('other.a3071')}}:{{descTotalNum}}</div>
			
			<el-table :data="bindItemList02" height="450px" >
				<el-table-column width="80" :label="$t('other.a66')" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<el-popover placement="top-start" title="" trigger="hover">
							<img :src="changeImgURL(scope.row)" alt="" style="width: 150px;height: 150px">
							<img slot="reference" :src="changeImgURL(scope.row)" style="width: 30px;height: 30px">
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column  :label="$t('other.a3073')" :show-overflow-tooltip="true">
					<template slot-scope="scope" >
						<!-- <el-input v-model="scope.row.cusCode" ></el-input> -->
						<span>{{scope.row.cusCode}}</span>
					</template>
				</el-table-column>
				<el-table-column  label="sku" :show-overflow-tooltip="true">
					<template slot-scope="scope" >
						<!-- <el-input v-model="scope.row.skuName" ></el-input> -->
						<span>{{scope.row.skuName}}</span>
					</template>
				</el-table-column>
				<el-table-column  :label="$t('other.a3074')" >
					<template slot-scope="scope" >
						<el-input-number size="mini" v-show="isEditGoods" v-model="scope.row.rate"  :min="1"  ></el-input-number>
						
						<span v-show="!isEditGoods">{{scope.row.rate}}</span>
					</template>
				</el-table-column>
				<el-table-column  :label="$t('other.a3075')" :show-overflow-tooltip="true">
					<template slot-scope="scope" >
						<span >{{scope.row.reservedStock}}</span>
						
					</template>
				</el-table-column>
				<el-table-column  :label="$t('other.a3076')" :show-overflow-tooltip="true">
					<template slot-scope="scope" >
						<span >{{scope.row.unShipped}}</span>
					</template>
				</el-table-column>
				<div style="float: right;margin: 15px;">
					<el-button @click="cleanForm">{{$t('userStoreItems').caigou.qingkong}}</el-button>
					<el-button @click="createOrder" type="primary">{{$t('userStoreItems').caigou.submit}}</el-button>
				</div>
				
			</el-table>
		</el-dialog>
		<!-- 开启关闭批量自动更新 -->
		<el-dialog :title="$t('userStoreItems').update.tip"  :visible.sync="dialogVisible01" width="30%" >
			<p class="visiableMessage_desc">{{visiableMessage}}</p>
			<span slot="footer" class="dialog-footer">
				<!-- <el-button size="mini" type="primary"  @click="dialogVisible01=false;isCloseUpdataBtn=false">{{$t('userStoreItems').update.open}}</el-button> -->
				<el-button  type="primary"  @click="closeUpdate">{{$t('other.a3029')}}</el-button>
				<!-- <el-button size="mini" type="primary" v-if="isOpenUpdataBtn" @click="closeUpdate_01">{{$t('userStoreItems').update.close01}}</el-button> -->
				<el-button  type="primary" v-if="isOpenUpdataBtn " @click="openUpdate">{{$t('other.a3030')}}</el-button></el-button>
			</span>
		</el-dialog>
		<el-dialog :title="$t('userStoreItems').Prompt" :visible.sync="dialogVisible" width="30%">
			<span>{{visiableMessage}}</span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogVisible = false">{{$t('userStoreItems').ok}}</el-button>
			</span>
		</el-dialog>
		<!-- 自动关联绑定详情 -->
		<el-dialog :title="$t('binditems').details.title" :visible.sync="TppCopy" center width="80%">
			<div class="quit-wapper">
				<span class="quit-wrapper-item">{{$t('binditems').details.success}}({{bindSuccess.length}})</span>
				<span class="quit-wrapper-item">{{$t('other.a1910')}}({{bindError.length}})</span>
			</div>
			<div class="quit-box" >
				<el-table style="margin-left: 10px;" :data="bindSuccess" height="350px" border>
					<el-table-column property="name" :label="$t('binditems').details.Img" width="60" :show-overflow-tooltip="true">
						<template scope="scope">
							<el-popover placement="top-start" title="" trigger="hover">
								<img :src="changeImgURL(scope.row)" style="width: 150px;height: 150px" />
								<img slot="reference" :src="changeImgURL(scope.row)" style="width: 30px;height: 30px">
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column property="name" :label="$t('binditems').details.name" width="250" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column property="itemSku" :label="$t('binditems').details.SKU"  :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column property="cusCode" :label="$t('binditems').details.cusCode"   :show-overflow-tooltip="true">
					</el-table-column>
					
				</el-table>
				<el-table style="margin-left: 10px;" :data="bindError" height="350px" border>
					<el-table-column property="name" :label="$t('binditems').details.Img" width="60" :show-overflow-tooltip="true">
						<template scope="scope">
							<el-popover placement="top-start" title="" trigger="hover">
								<img :src="scope.row.image" style="width: 150px;height: 150px" />
								<img slot="reference" :src="scope.row.image" style="width: 30px;height: 30px">
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column property="bindMsg" :label="$t('other.a677')"  :show-overflow-tooltip="true">
					</el-table-column>
				</el-table>
			</div>
			<div class="ttp-uu">
				<el-button @click="TppCopy=false" type="primary">{{$t('binditems').details.ok}}</el-button>
			</div>
			
		</el-dialog>

		<!-- 进入页面时的弹窗提示 -->
		<el-dialog
		:title="$t('other.a3077')"
		:visible.sync="showIntroduce"
		width="40%"
		>
		<div>
{{$t('other.a3078')}}
		</div>
		<span slot="footer" class="dialog-footer">
			<span style="font-size:12px;margin:0 20px;color:#409EFF;cursor: pointer" @click="nologerAlert()">{{$t('other.a3036')}}</span>
			<el-button type="primary" @click="showIntroduce = false">{{$t('other.a955')}}</el-button>
		</span>
		</el-dialog>

		<div class="header-top">
			<!-- 一级菜单栏 -->
			<div class="query-list">
				<div class="query-list-tcp">
					<div style="width: 150px;">
						<el-select @change="getShopItems(warehouseId)" v-model="warehouseId" placeholder="" >
							<el-option v-for="item in warehouseOption" :key="item.storeId" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</div>
					<div class="query-list-bbc create">
						<el-input style="width: 400px;margin:0 5px;" clearable  :placeholder="$t('userStoreItems').search_tip" v-model="cusCode"></el-input>
						<el-button  type="primary" @click="goTosearch()">{{$t('userStoreItems').search}}</el-button>
					</div>
					<div class="query-list-bbc create">
						<span style="display:inline-block;min-width: 130px;text-align:center;color:#409EFF;cursor:pointer" @click="showIntroduce=true">{{$t('other.a3077')}}</span>
					</div>
				</div>
	
				<div class="query-list-tcp">

					<div class="create">
						<el-button type="primary" @click="opensluginreminder" >{{$t('other.a203')}}</el-button>
						<span class="cirlle">{{unsalable.length}}</span>
					</div>

					<el-tooltip style="margin-right:15px"   effect="light" :content="$t('other.a3079')" placement="bottom">
					<div class="create">
						<el-button type="primary" @click="openopenQueHuotixing" >{{$t('userStoreItems.quehuo')}}</el-button>
						<span class="cirlle">{{xuehuoInfocount}}</span>
					</div>
					</el-tooltip>
				</div>
			</div>
			<!-- 二级菜单栏 -->
			<div class="query-list-tcp">
				<el-checkbox style="margin:0 15px 0 5px;" v-model="checked_01"  @change="targetAll"><span style="font-size: 18px;">{{$t('other.a2520')}} ({{targetListCopy.length}})</span></el-checkbox>
				
				<el-dropdown  style="margin-left: 15px;"   type="primary">
					<el-button type="primary">
							{{$t('other.a2521')}}<i class="el-icon-arrow-down el-icon--right"></i>
					</el-button>
				  <el-dropdown-menu slot="dropdown">
					 <el-dropdown-item style="font-size:18px;padding:10px 30px" @click.native="piliangenxin(0)">{{$t('other.a3037')}}</el-dropdown-item>
					 <el-dropdown-item style="font-size:18px;padding:10px 30px" @click.native="massMoveIn()">{{$t('other.a2522')}}</el-dropdown-item>
				    <el-dropdown-item style="font-size:18px;padding:10px 30px" @click.native="massDeletd()">{{$t('other.a2523')}}</el-dropdown-item>
					<el-dropdown-item style="font-size:18px;padding:10px 30px" @click.native="fixData()">{{$t('other.a3039')}}</el-dropdown-item>
				  </el-dropdown-menu>
				</el-dropdown>
				<el-button style="margin-left: 15px;"  type="primary" @click="isExtened =!isExtened">{{!isExtened ? $t('other.a2690') : $t('other.a2691')}}</el-button>
				<!-- <el-button style="margin-left: 15px;"  type="primary" @click="createGoods()">创 建 产 品 </el-button> -->
				<el-dropdown  style="margin-left: 15px;"   type="primary">
					<el-button type="primary">
							{{$t('other.a3080')}} <i class="el-icon-arrow-down el-icon--right"></i>
					</el-button>
				  <el-dropdown-menu slot="dropdown">
					 <el-dropdown-item style="font-size:18px;padding:10px 30px" @click.native="handleCreateCopy()">{{$t('other.a3041')}}</el-dropdown-item>
					 <el-dropdown-item style="font-size:18px;padding:10px 30px" @click.native="goToInsertGoods()">{{$t('other.a3042')}}</el-dropdown-item>
				  </el-dropdown-menu>
				</el-dropdown>
				<el-button style="margin-left: 15px;"  type="primary" @click="transproductDia=true">{{$t('other.a3081')}}</el-button>
				<el-button style="margin-left: 15px;"  type="primary" @click="exportStoreData()">{{$t('other.a3082')}}</el-button>
			</div>
		</div>
		<div class="mygoods-list">
			<div class="mygoods-list-nodata" v-if="!newUserstoreItem.length " >--{{$t('userStoreItems').nodata}}--</div>
			<div class="my-goods-data" v-else>
				<div v-for="(outeritem,indexOne) in newUserstoreItem" :key="indexOne" >
					<div class="list-item">
						<el-row>
							<el-col :span="24">
								<div style="border-bottom: 1px solid #E0E0E0;">
									<div class="outPsku">
										<el-tooltip class="item" effect="dark" :content="outeritem.itemSku" placement="bottom">
											<div style="display: flex;">
												<el-checkbox v-model="outeritem.checked" style="margin-right: 20px;" @change="getPsku(outeritem,1,indexOne)"></el-checkbox>
												<span style="color: orangered;display:flex">
													<span> {{$t('other.a2145')}}：</span>
													<span style="color: orangered;display:inline-block;overflow: hidden;text-overflow: ellipsis; white-space: nowrap;max-width:450px"  v-show="!outeritem.checked01">{{outeritem.itemSku}}</span>
													<el-input v-show="outeritem.checked01" style="width: 250px;"  :placeholder="$t('other.a319')" v-model="outeritem.itemSku"></el-input>
													<i v-show="!outeritem.checked01" style="line-height:50px"  class="el-icon-edit" @click="outeritem.checked01 =true"></i>
													<span style="margin-left: 12px;cursor: pointer;color: #1890FF;font-weight: initial;" v-show="outeritem.checked01" @click="fixItemSku(outeritem)">{{$t('other.a166')}}</span>
												</span>
									   	</div>
										</el-tooltip>
										<div style="display: flex;">
											<div style="font-size: 14px;font-weight: initial;margin-right: 20px;">{{$t('other.a57')}}：{{getTime01(outeritem.createTime)}}</div>
											<div style="font-size: 16px;font-weight: initial;margin-right: 20px;cursor: pointer;" >
												<el-button  type="primary" @click="outeritem.checked02=!outeritem.checked02">{{$t('other.a2146')}}/{{$t('other.a2147')}}</el-button>
											</div>
											<el-dropdown style="width: 183px;" >
												<el-button type="primary">
													  {{$t('other.a3043')}}<i class="el-icon-arrow-down el-icon--right"></i>
												</el-button>
											  <el-dropdown-menu slot="dropdown">
												  <el-dropdown-item style="font-size:18px;padding:10px 30px" @click.native="toBind(outeritem.groupId,outeritem.itemSku)"><span >{{$t('other.a3044')}}</span></el-dropdown-item>
												  <el-dropdown-item style="font-size:18px;padding:10px 30px" @click.native="autoBind(outeritem.groupId)"><span >{{$t('other.a3045')}}</span></el-dropdown-item>
												  <!-- <el-dropdown-item style="font-size:18px;padding:10px 30px" @click.native="getBindGoods(outeritem)"><span >编辑绑定情况</span></el-dropdown-item> -->
											    <el-dropdown-item style="font-size:18px;padding:10px 30px" @click.native="deleteGroupTpp(outeritem.groupId)"><span >{{$t('other.a312')}}</span></el-dropdown-item>
											  </el-dropdown-menu>
											</el-dropdown>
										</div>
									</div>
									<div style="display: flex;justify-content: space-between;box-sizing: border-box;padding: 10px 10px 10px 20px;">
										<div style="display: flex;">
											<div class="goods-pic">
												<img v-image-preview :src="outeritem.image ? outeritem.image :  outeritem.storeItems ? outeritem.storeItems[0].image : ''">
												 <span class="fixPic" @click="changePic(outeritem.groupId,0)">{{$t('other.a2692')}}</span>
											</div>
											<div style="width: 300px;margin-left: 20px;">{{outeritem.groupName}}</div>
											<div style="width: 180px;margin-left: 20px;text-align:right">
												<div>{{$t('other.a2149')}}：{{outeritem.storeItems ? outeritem.storeItems.length : 0 }} </div>
												<div>{{$t('other.a2150')}}：{{outeritem.qytInStore }}</div>
											</div>
											<div style="margin-left:20px">
												<el-dropdown  style="margin-left: 15px;"   type="primary">
													<el-button size="mini" type="primary">
															{{$t('other.a2785')}} <i class="el-icon-arrow-down el-icon--right"></i>
													</el-button>
												<el-dropdown-menu slot="dropdown">
													<el-dropdown-item style="font-size:18px;padding:10px 30px" @click.native="handleCreate(outeritem)">{{$t('other.a3047')}}</el-dropdown-item>
													<el-dropdown-item style="font-size:18px;padding:10px 30px" @click.native="addChilderSKU(outeritem)">{{$t('other.a3048')}}</el-dropdown-item>
												</el-dropdown-menu>
												</el-dropdown>
												<!-- <el-button type="primary" size="mini" @click="addChilderSKU(outeritem)">{{$t('other.a2785')}}</el-button> -->
											</div>
										</div>
										<div >
											<el-button style="width:158px;margin-right:15px" type="primary" @click="getBindGoods(outeritem)">{{$t('other.a3049')}}</el-button>
										</div>
									</div>
								</div>
								<!-- 子sku -->
								<div  v-if="outeritem.checked02" v-for="(item,index) in outeritem.storeItems ? outeritem.storeItems : []" :key="index">
									<div class="item-view">
										<div class="goods-desc">
											<div class="goods-title-desc-wrapper">
												<el-checkbox v-model="item.checked" style="margin-right: 20px;" @change="getPsku(item,2,indexOne,index)"></el-checkbox>
												<div style="width:60px;height:60px;margin:20px 10px 0 0 ;position:relative">
													<img v-image-preview width="100%" :src="item.image">
													<span class="fixPic" @click="changePic(item.cusCode,1)">{{$t('other.a2692')}}</span>
													<!-- <el-button type="primary" size="mini">{{$t('other.a238')}}</el-button> -->
													
												</div>
												<div class="goods-title-desc-box">
													<div style="font-size: 16px;color: red;padding-bottom: 5px;" v-if="isEdit !== index">
														{{$t('other.a2139')}}：{{item.skuName}}
														<i  style="line-height:10px"  class="el-icon-edit" @click="handleEditStreet(index)"></i>
													</div>
													<div v-else>
														<el-input size="mini" style="width: 200px;;"
															  v-model="item.skuName"
															  :rows="2"
															  type="textarea"
															  autosize="autosize"
															  >
														</el-input>
														<span  style="margin-left: 12px;cursor: pointer;color: #1890FF;font-weight: initial;"  @click="confirm(item)">{{$t('other.a166')}}</span>
													</div>

													<div style="font-size: 16px;padding-bottom: 5px;" v-if="isEdit !== index">
														skuName：{{item.variationName}}
														<!-- <i  style="line-height:10px"  class="el-icon-edit" @click="handleEditStreet(index)"></i> -->
													</div>
														<div v-else>
														<el-input size="mini" style="width: 200px;;"
															  v-model="item.variationName"
															  :rows="2"
															  type="textarea"
															  autosize="autosize"
															  >
														</el-input>
														<!-- <span  style="margin-left: 12px;cursor: pointer;color: #1890FF;font-weight: initial;"  @click="confirm(item)">{{$t('other.a166')}}</span> -->
													</div>
													<div class="goods-item-a">{{$t('userStoreItems').cusCode}}：{{item.cusCode}}</div>
													<div class="goods-item-a">{{$t('userStoreItems').userName}}：{{item.userName}}</div>
													<div class="goods-item-a">{{$t('userStoreItems').warehouse}}：{{item.storeName}}</div>
													
													<div class="goods-item-a" v-if="show">
														<div v-if="isEdit !== index">{{$t('userStoreItems').cost}}：{{item.cost}}</div>
														<div v-else>
															{{$t('userStoreItems').cost}}：
															<el-input size="mini" style="width: 80px;;"
																  v-model="item.cost"
																  >
															</el-input>
															<span style="color:red;font-size:14px;margin-left:10px">{{$t('other.a2121')}}</span>
														</div>
													</div>
												
												</div>
												<div class="goods-title-desc">
													<div class="goods-item-a">
														{{$t('userStoreItems.Quantitytobeshipped')}}
														<el-tooltip class="item" effect="dark" :content="$t('other.a2536')" placement="top-start">
															<i class="el-icon-question oook"></i>:
														</el-tooltip>
														:
														{{item.auditedStock}}
													</div>
													<div class="goods-item-a">
													     {{$t('userStoreItems').shipping_stock}}
														 <el-tooltip class="item" effect="dark" :content="$t('other.a2542')" placement="top-start">
															<i class="el-icon-question oook"></i>:
														</el-tooltip>
														:
														 
														 {{item.unShipped-item.assibleUnshiped}}({{$t('other.a251')}}) + {{item.assibleUnshiped}}({{$t('other.a252')}})
													</div>
													<div class="goods-item-a">
														{{$t('userStoreItems').online_stock}}
														 <el-tooltip class="item" effect="dark" :content="$t('other.a1122')" placement="top-start">
															<i class="el-icon-question oook"></i>:
														</el-tooltip>
														:
														{{item.stock}}
													</div>
													<div class="goods-item-a yihdf">
														{{$t('other.a2540')}}
														 <el-tooltip class="item" effect="dark" :content="$t('other.a2541')" placement="top-start">
															<i class="el-icon-question oook"></i>:
														</el-tooltip>
														：
														<span v-show="!item.checked_one">{{item.reservedStockTotal}}</span>
														<span v-show="item.checked_one"><el-input style="width: 50px;padding:0 5px" size="mini" v-model="item.reservedStock " /></span>
														<span v-show="item.checked_one"><el-input style="width: 50px;padding:0 5px" disabled size="mini" v-model="item.reservedStockCopy" /></span>
														



														 <i  style="margin-left: 15px;color: #409EFF;font-size: 16px;cursor: pointer;" v-show="!item.checked_one && !item.autoReserved"  @click="changeStock(outeritem,item,indexOne,index)" class="el-icon-edit " ></i>

                  										<el-button style="margin-left: 15px;" v-show="item.checked_one"  @click="changeStock(outeritem,item,indexOne,index)" size="mini" type="danger">{{$t('other.a145')}}</el-button>

														<el-switch
														  style="display: block;margin-left:15px"
														  v-model="item.autoReserved"
														  @change="changeLockStock(item)"
														   active-color="#13ce66"
														   inactive-color="#ff4949"
														   :active-text="$t('other.a2543')"
														   :inactive-text="$t('other.a2544')">
														 >
														</el-switch>


													</div>
													<div class="goods-item-a">{{$t('userStoreItems').total_stock}}
														 <el-tooltip class="item" effect="dark" :content="$t('other.a1123')" placement="top-start">
															<i class="el-icon-question oook"></i>:
														</el-tooltip>
														:
														{{item.storeNum}}</div>
													<div class="goods-item-a yihdf">
														{{$t('other.a2546')}}
														<el-tooltip class="item" effect="dark" :content="$t('other.a3051')" placement="top-start">
														     <i class="el-icon-question oook"></i>:
														    </el-tooltip>
														<el-switch
														  style="display: block"
														  v-model="item.synchrony"
														  @change="updateShopeeItem(item)"
														   active-color="#13ce66"
														   inactive-color="#ff4949"
														   :active-text="$t('userStoreItems').on"
														   :inactive-text="$t('userStoreItems').off">
														 >
														</el-switch>
													</div>

												</div>
												<div class="goods-title-desc bbp">
													<div class="goods-item-a">
														<div >{{$t('userStoreItems.long')}}：{{item.packageLength ? item.packageLength : 0}} cm</div>
													</div>
													<div class="goods-item-a ">
													     <div >{{$t('userStoreItems.width')}}：{{item.packageWidth ? item.packageWidth : 0}} cm</div>
													     
													</div>
													<div class="goods-item-a">
														 <div >{{$t('userStoreItems.height')}}：{{item.packageHeight ? item.packageHeight : 0}} cm</div>
													</div>
													<div class="goods-item-a">
													<div >{{$t('userStoreItems.weight')}}：{{item.weight ? item.weight : 0}} kg</div>
													</div>
													<div class="goods-item-a">
													<div >{{$t('other.a1169')}}：{{item.address ? item.address : $t('other.a354')}}</div>
													</div>

													<div class="goods-item-a">
													<div v-show="item.encoding" >{{$t('other.a352')}}：{{item.encoding}}
														<i  style="line-height:10px"   class="el-icon-edit" @click="inputCode(item)"></i>
													</div>
													<el-button v-show="!item.encoding" size="mini" type="primary" @click="inputCode(item)">{{$t('other.a2517')}}</el-button>
													</div>
												</div>
												
											</div>
										</div>
										<div style="display:flex">
											<div class="btn-wrapper">

											<div class="btn-item-desc" >
												<el-button style="min-width: 130px;" type="primary"  size="medium"  @click.stop="updateComponent(item,indexOne,index)">{{$t('other.a3229')}}</el-button>
											</div>
											<div class="btn-item-desc" >
												<el-button style="min-width: 130px;" type="primary"  size="medium"  @click.stop="opendialogTableVisible(item)">{{$t('other.a2429')}}</el-button>
											</div>
											<div class="btn-item-desc" >
											    <el-dropdown>
											      <span class="el-dropdown-link">
											       <el-button style="min-width: 130px;" type="primary"  size="medium"  >{{$t('userStoreItems.more')}}</el-button>
											      </span>
											      <el-dropdown-menu slot="dropdown">
											        <!-- <el-dropdown-item @click.native="viewGoodsOrder(item.cusCode)"><span >{{$t('userStoreItems.vieworder')}}</span></el-dropdown-item> -->
													<el-dropdown-item @click.native="viewstoreoperaterecord(item)"><span >{{$t('userStoreItems.viewstockstore')}}</span></el-dropdown-item>
													<!-- <el-dropdown-item @click.native="viewStoreSales(item)"><span >{{$t('userStoreItems.viewsales')}}</span></el-dropdown-item> -->
											        <el-dropdown-item  @click.native="deleStoreItem(item.cusCode,outeritem)"><span>{{$t('userStoreItems.del')}}</span></el-dropdown-item>
											        
											      </el-dropdown-menu>
											    </el-dropdown>
											</div>
											<div class="btn-item-desc" >
											    <span style="display:inline-block;min-width: 130px;text-align:center;color:#409EFF;cursor:pointer"    @click="opendialogTableVisibleTwo(item,1)">{{$t('other.a3230')}}( {{$t('other.a964')}} {{item.parents.length}}{{$t('other.a1337')}})</span>
											</div>
											<div v-if="item.additions.length > 0" class="btn-item-desc" >
											    <span style="display:inline-block;min-width: 130px;text-align:center;color:#409EFF;cursor:pointer"    @click="opendialogTableVisibleTwo(item,2)">{{$t('other.a3231')}}( {{$t('other.a964')}} {{item.additions.length}}{{$t('other.a1337')}})</span>
											</div>
											</div>
											
										</div>
									</div>
								</div>
								
							</el-col>
						</el-row>
						
					</div>
				</div>
				<!-- 分页器 -->
				<div class="Pager">
				    <el-pagination
				      @size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-sizes="[15, 20, 30, 100]"
					:page-size="15"
					layout="total, sizes, prev, pager, next, jumper"
					:total="itemsCount">
				    </el-pagination>
				  </div>
			</div>
			
		</div>
		</div>
	</div>
</template>

<script>
	import api from '../../../api/api.js'
	import utils from '../../../utils/utils.js'
	import mygoods from '../../../api/moudles/mygoods.js'
	import QrcodeDialog from '../../../components/dialog/qrcodeDialog.vue'
	import TableDialog from './../components/table.vue'
	import userStoreItems from '../../../api/moudles/userStoreItems.js'
	import {
		mapState,
		mapActions,
		mapMutations
	} from 'vuex'
	export default {
		data() {
			return {
				warehouse: JSON.parse(localStorage.getItem('warehouse')),
				userShops: JSON.parse(localStorage.getItem('shopIdInfo')),
				userInfo: JSON.parse(localStorage.getItem('userInfo')),
				shophasAuthorization:JSON.parse(localStorage.getItem('shophasAuthorization')),
				warehouseOption:[],
				warehouseId: '',
				componentValue:'null',
				descTotalNum:0,
				chosedStore: '',
				sluginreminder:false,
				shipCost:'',
				maincusCode:0,
				itemNameQuery: '',
				statusValue: '',
				isChooseList: [],
				bindItemList: [],
				caigouTable: false,
				bindTable: false,
				count: 0,
				dialogVisible: false,
				remindDialog: false,
				itemCount: 0,
				arr: [],
				showIntroduce:false,
				isBindItemModel: false,
				sellerMessage: "",
				visiableMessage: '',
				openDialog:false,
				stockRemindList: [],
				remindCount: 0,
				selectShop: '',
				productCode:false,
				errorDia:false,
				listErrorOptions:[],
				currentPage:0,
				isPresale:false,
				offset:15,
				isEdit:-1,
				updatPic:false,
				isComponent:false,
				parentSkuDia:false,
				transproductDia:false,
				secondPws:'',
				commfire:true,
				dialogTableVisible:false,
				dialogTableVisibleTwo:false,
				qty:null,
				autosize:{
					minRows: 2
				},
				cusCode:'',
				targetStoreid:null,
				showTable:false,
				valueoop: true,
				textUpdate:" ",
				dialogVisible01:false,
				oooop:{},
				cuscodeBand:null,
				tragetList:[],
				handleParam:null,
				imgObj:{
					imageUrl:'',
					key:'',
					methods:null
				},
				checked_01:false,
				isOpenUpdataBtn:false,
				isCloseUpdataBtn:false,
				value1: '',
				openQueHuochuankao:false,
				showSales:false,
				salesItem:null,
				fileList2: [],
				storeData:{},
				itemCoding:null,
				instockdia:false,
				bindItemList01:[],
				bindItemList02:[],
				token:{
					token:JSON.parse(localStorage.getItem('userInfo')).token
				},
				limitNum: 1,
				fileList: [],
				barCode:'',
				setRate:false,
				createProduct:false,
				targetList:[],
				targetListCopy:[],
				isEditGoods:false,
				TitleDesc:'',
				bindInfo:false,
				paramsCopy:{},
				showTTp:false,
				p_sku_Info:null,
				TppCopy:false,
				bindSuccess:[],
				updataCodingParams:{},
				getDataList:null,
				bindError:[],
				isExtened:true,
				descText:this.$t('other.a3016')
				
			
				
				
				       
			}
		},
		components: {
			QrcodeDialog,
			TableDialog
		},
		
		computed: {
			...mapState({
				mygoodslist: state => state.mygoods.mygoodslist,
				userId: state => state.shopaccess.userInfo.userId,
				userStormList: state => state.userStoreItems.userStormList,
				itemsCount: state => state.userStoreItems.itemsCount,
				deleTip: state => state.userStoreItems.deleTip,
				deletSuccess: state => state.userStoreItems.deletSuccess,
				getDateSuccess:state => state.userStoreItems.getDateSuccess,
				xuehuoInfo:state => state.userStoreItems.xuehuoInfo,
				xuehuoInfocount:state => state.userStoreItems.xuehuoInfocount,
				secondPassword:state=>state.shopaccess.secondPassword,
				newUserstoreItem:state=>state.userStoreItems.newUserstoreItem,
				refresh:state=>state.userStoreItems.refresh,
				slugInReminder:state => state.userStoreItems.slugInReminder,
				unsalable:state => state.userStoreItems.unsalable,
				
			}),
			
	
			
			show(){
				return  this.secondPassword
			},
			calTotal(){
				let num=0
				this.isChooseList.forEach(p => {
					num=parseInt(p.num) + num
				})
				return num
			},
			
		
			remindList() {
				return this.stockRemindList;
			},
			
			
		
			
			
		},
		watch:{
			errorDia(){
				if(!this.errorDia){
					this.listErrorOptions=[]
					this.resetPage()
					this.getStoreItem(this.getDataList)
				}
			},

		
		
			refresh(){
				if(this.refresh){
					this.checked_01=false
					this.targetList=[]
					setTimeout(() => {
						this.ttp()
					},1000)
				}
			},
			cusCode(){
				if(this.cusCode === "")
				this.getShopItems()
			},
			deletSuccess(){
				if(this.deletSuccess === "success") {
					this.open2(this.$t('other.a3017'))
				}else if(this.deletSuccess === "failed") {
					this.open3(this.$t('other.a3018'))
				}
			},
			getDateSuccess(){//开关或关闭自动更新后，触发这个再次刷新页面
				if(this.getDateSuccess) {
					this.getShopItems()
				}
			},
			dialogTableVisible(){
				if(!this.dialogTableVisible){
					this.isEditGoods=false
				}
			},
			newUserstoreItem(){
				console.log('listTartget',arr)
				let arr=[]
				this.newUserstoreItem.forEach(p => {
					p.storeItems.forEach(k => {
						if(k.checked){
							arr.push(k)
						}
					})
				})

				console.log('listTartget',arr)
			},
			targetList(){

				let arr=[]
				this.targetList.forEach(p => {
					if(p.checked){
						arr.push(p)
					}
				})
				let list=[]
				let obj={}

				for (var i = 0; i < arr.length; i++){
					if(!obj[arr[i].cusCode]){
						list.push(arr[i])
						obj[arr[i].cusCode]=true
					
					}
				}

				this.targetListCopy=list
				console.log('listTargt',arr)
			},
			isExtened(){
				
				if(this.isExtened){
					this.newUserstoreItem.forEach(p => {p.checked02=true})
				}else{
					this.newUserstoreItem.forEach(p => {p.checked02=false})
				}
			}	
		},
		created(){
			this.ttp()
			
		},
		methods: {
			...mapActions('userStoreItems', [
				'getStoreItem',
				'createCaiGouTable',
				'viewBindItems',
				'deleStoreItems',
				'jiebanItems',
				'updateItemInfo',
				'updateStoreItem',
				'updateShopeeItemStock',
				'sellerUpdateStoreItemDetail',
				'sellerUpdateSynchrony',
				'isAutoPre',
				'getStockRemind',
				'getStoreSales',
				'getStoreProductInventoryTurnover',
				'getInstockoperaterecore',
				'fileUpload',
				'updatRate',
				'deleteGroup',
				'updateGroup',
				'updateIsAutoPre',
				'getTableList',
				'updateBindStoreItem',
				'viewBindInfo'
				
				]),
				...mapActions('mygoods', [
					'bindBYsku'
					]),
					
				...mapMutations('userStoreItems', [
					'TARGET_ALL',
					'GET_DATA_STATUS_COLSE',
					'KEEP_CHOOSED_ITEM',
					'SET_REPLENISHMENT_PREIOD',
					'GET_UNSALABLE_DATA'
				]),

				exportStoreData(){
					let list=[]
					userStoreItems
					.getStoreItem(this.getDataList)
					.then(res => {
						if(res.code === 200) {
							console.log('仓库产品的item',res.data)
							res.data.groups.forEach(p => {
								if(p.storeItems){
									p.storeItems.forEach(i => {
										list.push({
											'用户帐号':i.userId,
											'用户昵称':i.userName,
											'产品名称':i.itemName,
											'仓库编码':i.cusCode,
											'在仓库存':i.storeNum,
											'线上库存':i.stock,
											'仓库Id':i.storeId,
											'仓库母sku':p.itemSku,
											'仓库子sku':i.skuName,
											'待发数量':i.unShipped,
											'长（cm）':i.packageWidth,
											'宽（cm）':i.packageLength,
											'高（cm）':i.packageHeight,
											'重量（kg）':i.weight

										})

									})
								}
							})

							let arr= ['用户帐号','用户昵称','产品名称','仓库编码','在仓库存','线上库存','仓库Id','仓库母sku','仓库子sku','待发数量','长（cm）','宽（cm）','高（cm）','重量（kg）']
							utils.exPortEXml(list,arr,'warehouseProduct')
							console.log('list',list)
							
						}
					})

					

				},
				inputCode(item){
					console.log(item)
					
					this.itemCoding=item
					
					this.updataCodingParams={
						userId:this.userId,
						storeId:item.storeId,
						cusCode:item.cusCode,
					}
					this.productCode=true
				},

				transformPorduct(){
					console.log(this.targetStoreid)
					userStoreItems
					.copyStoreItemByStore({
						storeId:this.warehouseId,
						targetStoreId:this.targetStoreid,
						type:0,
						userId:this.userId
					})
					.then(res => {
					if(res.code === 200 ){
					console.log('desc',res.data)
					this.$message.success(this.$t('other.a2623'))
					this.transproductDia=false
					this.targetStoreid=null
					}else{
					this.$message.warning(res.msg)
					this.targetStoreid=null
					}
					})
				},

				submitCoding(){
					console.log(this.barCode)
					this.updataCodingParams.encoding=this.barCode
					
					userStoreItems
					.updateEncoding(this.updataCodingParams)
					.then(res => {
						if(res.code == 200) {
							this.$message.success(this.$t('other.a2594'))
							this.productCode=false
							this.itemCoding.encoding=JSON.parse(JSON.stringify(this.barCode))
							this.barCode=''
						}else{
							this.$message.warning(res.msg)
						}	
					})
				},

				calcTotal(item){
					let num=0
					if(item.parents.length){
						item.parents.forEach(p => {
							num += p.rate
						})
					}
					console.log(num )
					return num
				},


				handleCreate(item){
					console.log(item)
					this.handleParam=item
					this.openDialog=true
					this.TitleDesc=this.$t('other.a3232')
				},
				handleCreateCopy(){
					this.$router.push({path:'/createProduct',query:{
						from: JSON.stringify(this.$route.path),
						storeId:JSON.stringify(this.warehouseId),
						addition:JSON.stringify(false),
						components:JSON.stringify(true)
					}})
				},

				goToInsertGoods(){
					this.$router.push({path:'/mygoods/shopee',query:{component:true}})
				},

				createItemNotProduct(data){
					console.log('data',data)
					let params={
						addition:false,
						address:null,
						component:true,
						cost:0,
						cusCode:0,
						encoding:null,
						groupId:this.handleParam ? this.handleParam.groupId : null,
						groupName:this.handleParam ? this.handleParam.groupName : null,
						image:data.imageUrl,
						itemSku:null,
						packageHeight:Number(data.height),
						packageLength:Number(data.long),
						packageWidth:Number(data.width),
						weigth:Number(data.weigth),
						shopId:this.handleParam ? this.handleParam.shopId : null,
						shopee:true,
						skuName:data.name,
						storeId:this.handleParam ? this.handleParam.storeId : null,
						userId:this.userId,
						variationName:data.variationName,
					}

					console.log('params',params)
					userStoreItems   
					.addStoreItemNotProduct(params)
					.then(res => {
						if(res.code === 200) {
							this.$message.success(this.$t('other.a2566'))
							this.handleParam=null
							this.getStoreItem(this.getDataList)
						}else{
							this.$message.warning(res.msg)
						}
					})
				},

				reFresh(){
					this.resetPage()
					this.getStoreItem(this.getDataList)
				},

				createGoods(){
					this.createProduct=true
				},



				imgConfirm(){
					this.updatPic=false
					console.log(this.imgObj)
					if(this.imgObj.methods == 0){
						userStoreItems
						.updateStoreParentImage(this.imgObj)
						.then(res => {
							if(res.code === 200) {
								console.log('修改成功')
								this.fileList2=[]
								this.getShopItems()
							}
						})

					}else if(this.imgObj.methods == 1){
						userStoreItems
						.updateStoreItemImage(this.imgObj)
						.then(res => {
							if(res.code === 200) {
								console.log('修改成功')
								this.fileList2=[]
								this.getShopItems()
							}
						})
					}

					
				},

				 handlePreview(file) {
					 console.log(file.data)
					 this.imgObj.imageUrl=file.data
				
				},

				changePic(num,index){
					 this.updatPic=true
					this.imgObj.key=num
					this.imgObj.methods=index
					
				},

				addChilderSKU(item){
					console.log(item)
			
					this.$router.push({path:'/mygoods/shopee',query:{groupId:item.groupId,component:"products"}})
					
					
				},
				changeLockStock(item){
					console.log(item)
					let param={
						autoReserved:item.autoReserved,
						userId:this.userId,
						cusCode:item.cusCode,
						storeId:item.storeId
					}
					item.autoReserved=!item.autoReserved
					if(!item.autoReserved){
							this.$confirm(this.$t('other.a2595'), this.$t("other.a142"), {
							confirmButtonText: this.$t('other.a145'),
							cancelButtonText: this.$t('other.a146'),
							type: 'warning'
							}).then(() => {
								item.autoReserved=true
								param.autoReserved=true
								console.log(param)
								api
								.updateAutoReserved(param)
								.then(res => {
									if(res.code === 200) {
										this.$message.success(this.$t('other.a741'))
										this.getStoreItem(this.getDataList)
									}
								})
							})
		
					}else{
						this.$confirm(this.$t('other.a3065'), this.$t("other.a142"), {
							confirmButtonText: this.$t('other.a145'),
							cancelButtonText: this.$t('other.a146'),
							type: 'warning'
							}).then(() => {
								item.autoReserved=false
								param.autoReserved=false
								console.log(param)

								api
								.updateAutoReserved(param)
								.then(res => {
									if(res.code === 200) {
										this.$message.success(this.$t('other.a741'))
										this.getStoreItem(this.getDataList)
									}
								})
							})
					}
				

				},
				
				exportStore(){
					let params={
						userId:this.userId,
						offset:30,
						page:0,
						storeId:this.warehouseId,
					}
					userStoreItems
					.getStoreItemBystore(params)
					.then(res => {
						if(res.code === 200) {
							params.offset=res.data.count+1
							userStoreItems
							.getStoreItemBystore(params)
							.then(res => {
								if(res.code === 200) {
									console.log(res.data)
									let arr=[]
									res.data.items.forEach(p => {
										arr.push({
											'cusCode':p.cusCode,
											'itemId':p.itemId,
											'variationId':p.variationId,
											'itemName':p.itemName,
											'skuName':p.skuName,
											'storeNum':p.storeNum,
											'unShipped':p.unShipped,
											'stock':p.stock,
											'packageLength':p.packageLength,
											'packageWidth':p.packageWidth,
											'packageHeight':p.packageHeight,
											'weight':p.weight,
											'shopId':p.shopId,
											'shopName':p.shopName,
										})
									})
									utils.exportStore(arr)
								}
							})
						}
					})
					
				},
				
				openItems(num){
					if(num == 0) {
						this.newUserstoreItem.forEach(p => {p.checked02=true})
					}else{
						this.newUserstoreItem.forEach(p => {p.checked02=false})
					}
				},
				
				getBindGoods(item){
					this.bindInfo=true
					this.p_sku_Info=item
					this.viewBindInfo({groupId:item.groupId})
				},
				
				editorSuscode(){
					this.isEditGoods=!this.isEditGoods
				},
				fixData(){
					console.log(this.targetListCopy)

					this.paramsCopy={
						cusCode:this.targetListCopy.map(p => p.cusCode),
						storeId:this.warehouseId,
						component:true,
						// groupId:item.groupId

					}
					this.parentSkuDia=true
				},
				
				getShopItem(data){
					const params={
						offset:data.offset,
						page:data.page,
						userId:this.userId,
						storeId:this.warehouseId,
						sellerId:this.userId,
						cusCode:data.cusCode
					}
					this.showTable=true
					this.getTableList(params)
				},
				
				giveItem(data){
					console.log(data)
					let list = data.list
					let arr=[]
					let obj={}
					console.log(list)
					console.log(this.bindItemList02)
					list.forEach(p => {
						this.bindItemList02.push(p)
					})
					
					this.bindItemList02.forEach(p => {
						if(!obj[p.cusCode]) {
							arr.push(p)
							obj[p.cusCode] = true
						}
					})
					this.bindItemList02=JSON.parse(JSON.stringify(arr))
					
					
				},
				
				deletGoods(item){
					this.bindItemList02.forEach((p,index) => {
						if(p.cusCode == item.cusCode && p.itemId == item.itemId){
							this.bindItemList02.splice(index,1)
						}
					})
				},
				
				saveItems(){
					
					this.isEditGoods=!this.isEditGoods
					let arr=this.bindItemList02.map(p => {
						return {
							childrenId:p.cusCode,
							parentId:this.cuscodeBand,
							rate:p.rate
						}
					})
					let params={
						binds:arr,
						parentId:this.cuscodeBand,
						userId:this.userId
					}
					console.log(this.bindItemList02)
					console.log(params)
					// this.updateBindStoreItem(params)
				},
				
				addGoods(){
					console.log(5241)
					const params={
						offset:this.offset,
						page:this.currentPage,
						userId:this.userId,
						storeId:this.warehouseId,
						sellerId:this.userId,
						component:true,
						cusCode:''
					}
					this.showTable=true
					this.getTableList(params)
				},
				
				massDeletd(){
					let arr=[]
					let num =0
					this.targetListCopy.forEach(p => {
						arr.push({
							cusCode:p.cusCode,
							userId:this.userId,
							storeId:this.warehouseId
						})
					})

					console.log(arr)
				let desc=this.$t('other.a2154') + arr.length + this.$t('other.a2155')
				this.$confirm(desc, this.$t("other.a142"), {
				  confirmButtonText: this.$t('other.a145'),
				  cancelButtonText: this.$t('other.a146'),
				  type: 'warning'
					}).then(() => {
						userStoreItems
						.massDeleteStoreItem(arr)
						.then(res => {
							if(res.code === 200){
								
								res.data.forEach(p => {
									if(p.code == 0){
									
									}else{
										this.listErrorOptions.push({
											cusCode:p.cusCode,
											desc:p.msg
										})

										this.qty=this.listErrorOptions.length+this.$t('other.a2156')
										this.errorDia=true
										this.resetPage()
										
									}
								})

								if(!this.listErrorOptions.length){
									this.$message.success(this.$t('other.a565'))
									this.getStoreItem(this.getDataList)
									this.resetPage()
								}
							
							}
						})
					
					})
				},

				deleStoreItem(code,outerItem) {
				  this.$confirm(this.$t('other.a2157'), this.$t("other.a142"), {
				  confirmButtonText: this.$t('other.a145'),
				  cancelButtonText: this.$t('other.a146'),
				  type: 'warning'
					}).then(() => {
					console.log(123)
						let param={
							cusCode:code,
							userId:this.userId,
							storeId:this.warehouseId
						}
					
					this.deleStoreItems(param).then(res => {
						if(res.code == 200){
							if(res.data.code == 0){
								this.$message.success(this.$t('other.a565'))
								this.getStoreItem(this.getDataList)
							}else{
								this.listErrorOptions=[{
									cusCode:res.data.cusCode,
									desc:res.data.msg
								}]
								this.qty=1+this.$t('other.a2158')
								this.errorDia=true
							}
						}
						
					})
				  
				})
					
				},

				massMoveIn(){
				

					let arr=[]
				
						this.targetListCopy.forEach(p => {
								arr.push({
								cusCode:p.cusCode,
								component:false,
								userId:p.userId,
								storeId:p.storeId
							}) 	
						})
			

					console.log('arr',arr)
					
					let text=this.$t('other.a1059') + arr.length + this.$t('other.a2585')
				

					this.$confirm(text, this.$t("other.a142"), {
					  confirmButtonText: this.$t('other.a145'),
					  cancelButtonText: this.$t('other.a146'),
					  type: 'warning'
					}).then(() => {
						let total=0
						console.log(arr)
					  arr.forEach(p => {
						  	userStoreItems
							.updataComponent(p)
							.then(res => {
								console.log(res)
								if(res.code === 200) {
									total +=1
									if(total == arr.length){
										this.$message.success(this.$t('other.a2586'))
										setTimeout(() => {
											this.ttp()
										},300)
									}

									console.log('total',total)
								}else{
									this.$message.warning(res.msg)
								}
							})
					  	})
				
					  
					})
				},
				
				getPsku(item,num,indexOne,index){
					console.log(item,num,indexOne,index)
					if(num == 1){//最外层
							this.newUserstoreItem[indexOne].storeItems.forEach(k => {
							k.checked=item.checked
						})

						let arr=this.newUserstoreItem[indexOne].storeItems
				
						arr.forEach(p => {
							this.targetList.push(p)
						})

					}else if(num == 2){//最内层
							let tty=this.newUserstoreItem[indexOne].storeItems.filter(p => {
								return p.checked
							})
							if(tty.length !== this.newUserstoreItem[indexOne].storeItems.length){
								this.newUserstoreItem[indexOne].checked=false
							}

							console.log('tty',tty)
							console.log('targetList',this.targetList)
						
							let num=this.targetList.findIndex(p => {
								return  p.cusCode ==this.newUserstoreItem[indexOne].storeItems[index].cusCode 
							})
							console.log('num',num)
							if(num == -1){
								this.targetList.push(this.newUserstoreItem[indexOne].storeItems[index])
							}else{
								this.targetList.splice(num,1)
							}

							
					}
					
					
				},
				
				deleteGroupTpp(id){
					this.$confirm(this.$t('other.a669'), this.$t("other.a142"), {
					  confirmButtonText: this.$t('other.a145'),
					  cancelButtonText: this.$t('other.a146'),
					  type: 'warning'
					}).then(() => {
					  
					  this.deleteGroup([{groupId:id,userId:this.userId,storeId:this.warehouseId}])
					})
				},
				
				
				toBind(id,sku){
					console.log(id)
					this.$router.push({path:'/binditemsTab',query:{groupId:id,itemSku:sku}})
				},
				
				autoBind(groupId){
					
					
					mygoods
					.bindBYsku({groupId})
					.then(res => {
						if(res.code === 200 ){
							console.log('匹配sku绑定仓库商品',res.data)
							this.bindSuccess=res.data.succcessItems
							this.bindError=res.data.errorItems
							this.TppCopy=true
						}else{
							this.$message.warning(res.msg)
						}
					})
				},
		
				
		
				fixRate(item){
					if(item.rate <=0 || (item.hasVariation ? item.variation.rate <= 0 : false)){
						this.$message.error(this.$t('other.a3020'))
						return
					}
					
					console.log(item)
					item.setRate=false
					if(item.shopee){
						this.updatRate({
							itemId:item.hasVariation ? item.variation.itemId : item.itemId,
							rate:item.hasVariation ? item.variation.rate : item.rate ,
							variationId:item.hasVariation ? item.variation.variationId : 0,
							type:0,
						})
					}
				},
				
				fixItemSku(item){
					console.log(item)
					item.checked01=false
					item.itemSku=item.itemSku
					this.updateGroup(item)
				},
				
				// 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
				    beforeUploadFile(file) {
				      // console.log(file)
				      const extension = file.name.substring(file.name.lastIndexOf('.') + 1)
				      const size = file.size / 1024 / 1024
				      if (extension !== 'xlsx') {
				        this.$notify.warning({
				          title: this.$t('other.a1507'),
				          message: this.$t('other.a3021')
				        })
				      }
				      if (size > 10) {
				        this.$notify.warning({
				          title: this.$t('other.a1507'),
				          message: this.$t('other.a3022')
				        })
				      }
				    },
				     // 文件状态改变时的钩子
				    fileChange(file, fileList) {
				      // console.log(file)
				      // console.log(fileList)
				    },
				    // 文件超出个数限制时的钩子
				    exceedFile(files, fileList) {
				      this.$notify.warning({
				        title: this.$t('other.a1507'),
				        message: this.$t('other.a2408')+` ${
				          this.limitNum
				        } `+this.$t('other.a2409')+` ${files.length + fileList.length} `+this.$t('other.a1337')
				      })
				    },
				    // 文件上传成功时的钩子
				    handleSuccess(res, file, fileList) {
				      console.log(res)
				     // this.formData.url = res.data  //服务器返回的文件地址
				      this.$message({
				        message: this.$t('other.a3023'),
				        type: 'success'
				      })
				      this.$refs.uploadExcel.clearFiles()// 清楚上次上传记录
				    },
				    // 文件上传失败时的钩子
				    handleError(err, file, fileList) {
				      this.$message.error(err.msg)
				    },
				
				
				importExcel(file) {
				   console.log(file)
				  let params={
					   account:this.userId,
					   file:file,
					   storeId:10100000
				   }
				    console.log(params)
				   this.fileUpload(params)
				},
				goToABC(){
					let router = this.$router.resolve(
					  { 
					    name: "treemap" ,
					  }
					);
					window.open(router.href, '_blank');
				},
				getmmn(num){
					let ttp=utils.getRecentSevenDay(num)
					let ccp =new Date(ttp)
					return ccp
				},
				//查看仓库的销售情况
				viewStoreSales(item){
					console.log(item)
					let params={
						end:utils.getchinastadarTime(0),
						start:utils.getchinastadarTime(-7),
						userId:this.userId,
						cusCode:item.cusCode
					}
					
					this.getStoreSales(params)
					this.getStoreProductInventoryTurnover(params)
					this.salesItem=params
					this.showSales=true
				},
				//查看仓库库存操作纪录
				viewstoreoperaterecord(item){
					this.instockdia=true
					this.maincusCode=item.cusCode
					let params={
						cusCode:item.cusCode,
						end:utils.CurdateAddoneday(utils.getRecentDays(0)),
						start:utils.getRecentDays(-7),
						offset:50,
						page:0,
						userId:this.userId
					}
					console.log(params)
					this.getInstockoperaterecore(params)
				},
				//查看仓库产品的订单
				viewGoodsOrder(cusCode) {
					console.log(cusCode)
					this.$router.push({path:'/orders/shopee',query:{cusCode:cusCode}})
				},
				
				getttp(item){
					let arr=[]
					arr.push(item)
					console.log(arr)
					return true
				},
				//开启预售
				autoPre(item){
					console.log(item)
					this.isAutoPre(item)
				},
				fixPresale(item){
					item.setPresale=false
					this.updateIsAutoPre(item)
				},
				
				platform(ttp){
					if(ttp) {
						return 'shopee'
					}else{
						return 'lazada'
					}
				},
				
				conversionShopName(shopId){
					
					let ttp=''
					this.userShops.forEach(p => {
						if(p.shopId === shopId) {
							return ttp=p.shopName
						}
					})
					return ttp
					// return this.warehouseOption.shopId
				},
				conversionSku(item){
					
					let sku=''
					if(item.hasVariation) {
						sku=item.variation.name
					}else{
						sku=item.name
					}
					
					return sku
				},
				
				
				closeUpdate_01(){
					console.log(this.targetList)
					this.targetList=[]
					this.TARGET_ALL(false)
					this.checked_01=false
					this.dialogVisible01=false
				},
				targetAll(){
					if(this.checked_01){
						this.newUserstoreItem.forEach(p => {
							p.checked=true
							p.storeItems.forEach(k => {
								k.checked=true
								this.targetList.push(k)
							})
						})

						
					}else{
						this.newUserstoreItem.forEach(p => {
							p.checked=false
							p.storeItems.forEach(k => {
								k.checked=false
								this.targetList.push(k)
							})
						})
					}
					
					console.log(this.targetList)
					
				},
				piliangenxin(num){
					if(num == 0) {
						this.isOpenUpdataBtn =true
						this.isCloseUpdataBtn=false
						if(!this.targetList.length) {
							this.showMessage(this.$t('userStoreItems').update.text04)
							return
						}
						this.showMessage01(this.$t('userStoreItems').update.text01)
					}else if(num == 1 ) {
						this.isCloseUpdataBtn =true
						this.isOpenUpdataBtn=false
						if(!this.targetList.length) {
							this.showMessage(this.$t('userStoreItems').update.text02)
							return
						}
						this.showMessage01(this.$t('userStoreItems').update.text03)
					}
				},
				//批量关闭自动更新在仓库存
				closeUpdate(item){
				    //  this.isCloseUpdataBtn=false
					if(this.targetListCopy.length > 0){
						let arr=[]
					let num=0
					this.targetListCopy.forEach(k => {
						arr.push( {
							synchrony:false,
							userId:k.userId,
							cusCode:k.cusCode,
							storeId:k.storeId
							
						})
					})
					
					arr.forEach(p => {
						this.sellerUpdateSynchrony(p).then(res => {

							if(res.code === 200 ) {
								num +=1
								if(num == arr.length){
									this.dialogVisible01=false
									this.resetPage()
									this.getStoreItem(this.getDataList)
									let desc=this.$t('other.a3057')+ num +this.$t('other.a3058')
									this.$message.warning(desc)
								}
							}else{
									this.$message.error(res.msg)
								}
						})
					})
					}else{
						this.oooop.synchrony=false
						
						this.sellerUpdateSynchrony(this.oooop).then(res => {
							if(res.code === 200 ) {
								this.$message.warning(this.$t('other.a3059'))
								
							}else{
								this.$message.error(res.msg)
							}

							this.dialogVisible01=false
						})
					}
					
					
				},
				//批量开启自动更新在仓库存
				openUpdate(){
				    if(this.targetListCopy.length > 0) {//批量选择开启
						let arr=[]
						let num=0
						this.targetListCopy.forEach(k => {
							arr.push( {
								synchrony:true,
								userId:k.userId,
								cusCode:k.cusCode,
								storeId:k.storeId
								
							})
						})
						arr.forEach(p => {
							this.sellerUpdateSynchrony(p).then(res => {
								if(res.code === 200 ) {
									num +=1
									if(num == arr.length){
										this.dialogVisible01=false
										this.resetPage()
										this.getStoreItem(this.getDataList)
										let desc=this.$t('other.a3057')+ num +this.$t('other.a3060')
										this.$message.success(desc)
									}
								}else{
									this.$message.error(res.msg)
								}
							})
						})
					}else{//点击开启
						this.oooop.synchrony=true
						this.sellerUpdateSynchrony(this.oooop).then(res => {
							if(res.code === 200 ) {
								this.$message.success(this.$t('other.a3061'))
								
							}else{
								this.$message.error(res.msg)
							}

							this.dialogVisible01=false
						})
					}
					
				},

				updateComponent(item,indexOne,index){
					console.log(item,indexOne,index)
					let params={
						cusCode:item.cusCode,
						component:false,
						userId:item.userId,
						storeId:item.storeId
					}

					this.$confirm(this.$t('other.a3233'), this.$t("other.a142"), {
					  confirmButtonText: this.$t('other.a145'),
					  cancelButtonText: this.$t('other.a146'),
					  type: 'warning'
					}).then(() => {
					  
					userStoreItems
					.updataComponent(params)
					.then(res => {
						if(res.code === 200) {
							this.$message.success(this.$t('other.a3234'))

							if(this.newUserstoreItem[indexOne].storeItems.length === 1){
								this.newUserstoreItem.splice(indexOne,1)
								
								return
							}
							this.newUserstoreItem[indexOne].storeItems.splice(index,1)
						}else{
							this.$message.warning(res.msg)
						}
					})
					  
					})
				},
				
				 updateShopeeItem(item){
					 let count =item.storeNum-item.unShipped
					this.oooop = item
				    let sync = item.synchrony
					item.synchrony=!item.synchrony
					if(sync){
						this.isOpenUpdataBtn=true
						this.isCloseUpdataBtn=false
						this.showMessage01(this.$t('userStoreItems').update.text05 + count + this.$t('userStoreItems').update.text06)
					}else{
						this.isCloseUpdataBtn=true
						this.isOpenUpdataBtn=false
						this.showMessage01(this.$t('userStoreItems').update.text07)
					}
				},
				
				updateShopeeItem007(item){
					console.log(item)
				},
				
				goBindproduct(){
					console.log(this.cuscodeBand)
					this.$router.push({path:'/binditemsTab',query:{cusCode:this.cuscodeBand,component:'products'}})
					this.dialogTableVisible=false
				},
				
				//搜索商品名称查找
				goTosearch(){
				 this.getShopItems()
				},
				jiebang(item){
					let arr=this.bindItemList01
					// if(arr.length === 1) {
					// 	this.showMessage(this.$t('userStoreItems').bindItem.tip)
					// 	return
					// }
					this.$confirm(this.$t('other.a209'), this.$t("other.a142"), {
					  confirmButtonText: this.$t('other.a145'),
					  cancelButtonText: this.$t('other.a146'),
					  type: 'warning'
					}).then(() => {
					  
					  this.jiebanItems(item).then(res => {
						  if(res.code === 200){
							  this.$message.success(this.$t('other.a1699'))
										this.bindItemList01.forEach((p,index)=>{
								if(p.hasVariation) {
									if(p.variation.itemId == item.variation.itemId && p.variation.variationId == item.variation.variationId  && p.variation.variationSku == item.variation.variationSku) {
										this.bindItemList01.splice(index,1)
									}
								}else{
									if(p.categoryId == item.categoryId && p.itemId == item.itemId  && p.itemSku == item.itemSku) {
										this.bindItemList01.splice(index,1)
									}
								}
											
							})
						  }else{
							  this.$message.warning(res.msg)
						  }
					  })
				
					})
					
				
				},
				
			
			opendialogTableVisible(item){
				this.isComponent=item.component
				console.log(item)
				this.cuscodeBand=item.cusCode
				this.bindItemList01=item.items
				this.bindItemList02=item.component ? item.parents :  item.children
				this.dialogTableVisible=true
			},
			opendialogTableVisibleTwo(item,num){
				let numTotal =0
				if(num == 1){
					this.isComponent=item.component
					console.log(item)
					this.cuscodeBand=item.cusCode
					this.bindItemList01=item.items
					this.bindItemList02=item.component ? item.parents :  item.children
					this.dialogTableVisibleTwo=true
					item.parents.forEach(p => {
					
						numTotal+=Number(p.unShipped)*Number(p.rate)
					})
					
					this.descTotalNum=numTotal

				}

				

				if(num == 2){
					this.isComponent=item.component
					console.log(item)
					this.cuscodeBand=item.cusCode
					this.bindItemList01=item.items
					this.bindItemList02=item.additions
					this.dialogTableVisibleTwo=true
				}
				
			},
			nologerAlert(){
				localStorage.setItem('usreFirstLogin',false)
				this.showIntroduce=false
			},
			//控制每页显示订单条数
			handleSizeChange(val) {
					 console.log(`每页 ${val} 条`);
					 this.offset=parseInt(`${val}`)
					 this.getDataList.offset=parseInt(`${val}`)
					 this.handleCurrentChange()
			  },
			  //显示当前第几页
			  handleCurrentChange(val) {
				  console.log(`${val}`)
				  this.resetPage()
				  this.currentPage=parseInt(`${val}`)
				  let ppg= `${val}` == 'undefined' ? 0 : (parseInt(`${val}`) -1) * this.offset
				  this.getDataList.page=ppg
				  this.getStoreItem(this.getDataList)
			  },
			  //重新将页面选择中状态默认为0
			  resetPage(){
				  this.targetList.forEach(p => {//切换页面时，操作前一面选中的仓库重置为默认
					  p.checked=false
				  })
				  this.checked_01=false
				  this.targetAll()
				  this.targetList=[]
				 
			  },
			  stockTotal(num1,num2) {
				  return num1 + num2
			  },
			ttp(){
				// if(!this.shophasAuthorization){
				// 	return
				// }
				
				console.log(this.warehouse)
				this.warehouse=utils.getAllstoreExpect(4)
				let userInfo=JSON.parse(localStorage.getItem('userInfo'))
				if(userInfo){
					this.secondPws=userInfo.secondPassword
				}
				this.warehouse.forEach(item => {
						this.warehouseOption.push({
							value:item.value,
							label:item.label 
						})
				})

				let storeId=JSON.parse(localStorage.getItem('storeId')) ?  JSON.parse(localStorage.getItem('storeId')) : this.warehouseOption[0].value
				console.log('storId',storeId)
				this.warehouseId=storeId ? storeId :this.warehouseOption[0].value;
				// localStorage.setItem('storeId',JSON.stringify(this.warehouseId))
				
				this.getDataList={
					offset:this.offset,
					page:this.currentPage,
					userId:this.userId,
					storeId:this.warehouseId,
					sellerId:this.userId,
					component:true,
					cusCode:''
				}

				
				 this.getStoreItem(this.getDataList)
				 this.getStockRemind({userId:this.userId,storeId:this.warehouseId}).then(res => {
					 if(res == 200) {
						 this.input10=JSON.parse(localStorage.getItem('userInfo')).shipDay
						 this.GET_UNSALABLE_DATA(this.warehouseId)
				  		 this.SET_REPLENISHMENT_PREIOD({shipbyday:this.input10,onway:this.radio})
						this.storeData={
							storeId:this.warehouseId,
							storeName:this.warehouseOption.find(item => item.value == this.warehouseId).label
						}
					 }
				 })
				
			},
			handleEditStreet(index){
				console.log(index)
				this.isEdit =index
				
			},
			confirm(item){
				console.log(item)
				this.sellerUpdateStoreItemDetail(item)
				this.isEdit=-1
			},
			openopenQueHuotixing() {
				this.openQueHuochuankao=true
				this.storeData={
					storeId:this.warehouseId,
					storeName:this.warehouseOption.find(item => item.value == this.warehouseId).label
				}

				console.log('storeData',this.storeData)
			},

			opensluginreminder(){
				console.log(this.sluginreminder)
				this.storeData={
					storeId:this.warehouseId,
					storeName:this.warehouseOption.find(item => item.value == this.warehouseId).label
				}
				this.sluginreminder=true
			},
			
			changeImgURL(item) {
				return item.image
			},
			getShopNmae(shopId) {
				return this.userShops.find(shop => shop.shopId == shopId).shopName;
			},
			getVariantNmae(row) {
				if (row.variationId == 0 || row.variationId == '') return ""
				return row.item.variations.find(variation => variation.variationId == row.variationId).name;
			},
			addBindToList(item, variation) {
				if (variation == null) {
					variation = {
						variationId: 0
					}
				}
				let param = JSON.parse(JSON.stringify(item));
				this.$set(param, "shopId", this.shipId);
				this.$set(param, "variation", variation);
				let isInList = false;
				for (let i = 0; i < this.bindItemList.length; i++) {
					if (this.bindItemList[i].itemId == param.itemId) {
						if (!this.bindItemList[i].hasVariation && !param.hasVariation) isInList = true;
						if (this.bindItemList[i].hasVariation && param.hasVariation &&
							this.bindItemList[i].variation.variationId == param.variation.variationId) isInList = true;
					}

				}
				if (!isInList) this.bindItemList.push(param);
				this.itemCount = this.bindItemList.length
				console.log(this.bindItemList)
			},
			commitBind() {
				let param = [];
				for (let i = 0; i < this.bindItemList.length; i++) {
					let binditem = {
						itemId: this.bindItemList[i].itemId,
						shopId: this.bindItemList[i].shopId,
						variationId: this.bindItemList[i].variation.variationId
					}
					param.push(binditem);
				}
				console.log(param);
				api.bindItem(param).then(res => {
					if (res.code === 200) {
						console.log(res.data)
						this.dialogVisible = true;
						this.visiableMessage = this.$t('other.a2732')
						this.bindTable = false;
					}
				})
			},
			deleteChoose(item) {
				this.$confirm(this.$t('other.a2157'), this.$t("other.a142"), {
				  confirmButtonText: this.$t('other.a145'),
				  cancelButtonText: this.$t('other.a146'),
				  type: 'warning'
				}).then(() => {
				  
				  this.userStormList.forEach(p => {
				  	if(p.cusCode === item.cusCode) {
				  		p.ttp=false
				  	}
				  })
				  console.log(item)
				  var index = this.isChooseList.findIndex(choose => {
				  	if (choose.itemId == item.itemId && choose.variation.variationId == item.variation.variationId) {
				  		return true
				  	}
				  })
				  this.isChooseList.splice(index, 1);
				  this.count = this.isChooseList.length;
				})
				
			},
			getShopItems() {
				this.getDataList.storeId=this.warehouseId
				this.getDataList.cusCode=this.cusCode
				this.getDataList.component= true,
				this.storeData={
					storeId:this.warehouseId,
					storeName:this.warehouseOption.find(item => item.value == this.warehouseId).label
				}

				this.GET_UNSALABLE_DATA(this.warehouseId)

				localStorage.setItem('storeId',JSON.stringify(this.warehouseId))
				// const params={
				// 	offset:this.offset,
				// 	page:this.currentPage,
				// 	userId:this.userId,
				// 	storeId:this.warehouseId,
				// 	sellerId:this.userId,
				// 	cusCode:this.cusCode
				// }
				//  console.log("选中仓库下的商品",params)
				 this.getStoreItem(this.getDataList)
			},
			getShopItems001() {
				 this.getDataList={
					offset:this.offset,
					page:this.currentPage,
					userId:this.userId,
					storeId:'',
					sellerId:this.userId,
					cusCode:''
				}
				 this.getStoreItem(this.getDataList)
			},

			 changeStock(outeritem,item,indexOne,index){
					console.log(outeritem,item,indexOne,index)
					this.newUserstoreItem[indexOne].storeItems[index].checked_one=!this.newUserstoreItem[indexOne].storeItems[index].checked_one
					let params={
						cusCode:this.newUserstoreItem[indexOne].storeItems[index].cusCode,
						storeNum:this.newUserstoreItem[indexOne].storeItems[index].reservedStock,

					}
					if(!this.newUserstoreItem[indexOne].storeItems[index].checked_one){
						api
						.updateReservedStock(params)
						.then(res => {
							if(res.code === 200){
								this.$message.success(this.$t('other.a665'))
								this.getStoreItem(this.getDataList)
							}
						})
					}
					
				},

			updateFromShopee() {
				if (this.selectShop == '') {
					this.showMessage(this.$t('other.a1917'))
				} else {
					api.updateItems(this.selectShop).then(res => {
						if (res.code === 200) {
							this.showMessage(this.$t('other.a1918'))
							this.getShopAllItems(this.selectShop)
						}
					})
				}

			},
			//创建采购单
			createOrder(data) {
				let variantList = [];
				let chooseList = this.isChooseList;
				if (chooseList.length == 0) {
					this.showMessage(this.$t('other.a2112'));
					return;
				}else if(!this.value1) {
					this.showMessage(this.$t('other.a2113'));
					return;
				}
				console.log('555',chooseList)
				let date_of_ship=utils.setNowTimes(this.value1).replace(/\s*/g,"");
				for (let i = 0; i < chooseList.length; i++) {
					if (chooseList[i].num == 0 || chooseList[i].num == undefined) {
						this.showMessage(this.$t('other.a2114'));
						return;
					}else if(chooseList[i].storeId !== chooseList[0].storeId) {
						this.showMessage(this.$t('other.a2115'))
						return 
					}
					let variation = {
						anotherName: chooseList[i].anotherName,
						cost: chooseList[i].cost,
						cusCode: chooseList[i].cusCode,
						image: chooseList[i].image,
						item_id: chooseList[i].itemId,
						itemName: chooseList[i].itemName,
						variantName: chooseList[i].skuName,
						variant_num: chooseList[i].num,
						variant_id:chooseList[i].variation.variationId 
					}
					variantList.push(variation);
				}
				let param = {
					message_to_seller: this.sellerMessage,
					storeId: chooseList[0].storeId,
					userId: chooseList[0].userId,
					variantList: variantList,
					date_of_ship:date_of_ship,
					shippingCost:this.shipCost,
				}
				console.log('hhh',param)
				
				api.createPurchaseOrder(param)
					.then(res => {
						if (res.code === 200) {
							console.log(res.data)
							this.showMessage(this.$t('userStoreItems').caigoudangtip + res.data.purchaseOrderId);
							this.caigouTable = false;
							this.isChooseList=[]
							this.count=0
							this.value1=''
							this.sellerMessage=''
							this.userStormList.forEach(p => {
									p.ttp=false
							})
							
						}
				})
			},
			showMessage(massage) {
				this.dialogVisible = true;
				this.visiableMessage = massage;
			},
			showMessage01(massage) {
				this.dialogVisible01 = true;
				this.visiableMessage = massage;
			},
			choseStatus(value) {
				console.log(value)
			},
			handleBtn() {
				console.log(this.bindItemList01)
			},
			getTime(time) {
				let ttp = time.slice(0, time.indexOf('T'))
				let ccp = time.slice(time.indexOf('T') + 1, time.indexOf('.'))
				return ttp + ' ' + ccp
			},
			getTime01(time){
				return utils.renderTime(time)
			},
			//状态转换
			conversionStatus(ttp) {

				return this.status[ttp]
			},
			unique(arr, type) { // 根据唯一标识orderId来对数组进行过滤
				const res = new Map(); //定义常量 res,值为一个Map对象实例
				//返回arr数组过滤后的结果，结果为一个数组   过滤条件是，如果res中没有某个键，就设置这个键的值为1
				if (type == 'loupan') {
					return arr.filter((arr) => !res.has(arr.bizid) && res.set(arr.bizid, 1))
				} else {
					return arr.filter((arr) => !res.has(arr.code) && res.set(arr.code, 1))
				}
			},
			tocaiguo(data) {
				if(data.items) {
					console.log(data)
					data.items.forEach(p => {
						p.storeItem.variation={
							variationId: 0,
							name: '',
							stock: 0
						}
						p.storeItem.num=Number(p.needStock01)
						this.isChooseList.push(p.storeItem)
					})
					console.log(this.isChooseList)
					this.count=this.isChooseList.length
				}
				api.getSellerStore(this.userInfo.userId).then(res => {
					if (res.code === 200) {
						console.log(res.data)
						this.storeList = [];
						for (let i = 0; i < res.data.length; i++) {
							this.storeList.push({
								value: res.data[i].storeId,
								label: res.data[i].storeName + '(' + res.data[i].userName + ')'
							})
						}
						this.chosedStore = '';
					}
				});
				this.caigouTable = true;
			},
			tobindItem() {
				this.bindTable = true;
			},
			getALLitems(item){
				item.checked03=!item.checked03
				if(item.checked03){
					item.storeItems.forEach(p => {
						this.isChooseList.forEach((k,index) => {
							if(p.cusCode === k.cusCode) {
								this.isChooseList.splice(index,1)
							}
						})
						this.targetVariation(p)
					})
				}else{
					item.storeItems.forEach(p => {
					
						this.targetVariation(p)
					})
				}
				
			},
			targetVariation(item, variation) {
				item.ttp=1
				let param = JSON.parse(JSON.stringify(item));
				this.$set(param, "num", 0);
				this.$set(param, "anotherName", "");
				this.$set(param, "variation", variation == null ? {
					variationId: 0,
					name: '',
					stock: 0
				} : variation)
				let isInList = false;
				for (let i = 0; i < this.isChooseList.length; i++) {
					if (this.isChooseList[i].cusCode === param.cusCode){
						isInList = true;
						this.isChooseList.splice(i,1)
						item.ttp=0
						}
				}
				if (!isInList) this.isChooseList.push(param);
				
				this.KEEP_CHOOSED_ITEM(this.isChooseList)
				this.count = this.isChooseList.length
				console.log('选中需要采购的商品',this.isChooseList)
			},
			cleanForm() {
				this.isChooseList = [];
				this.KEEP_CHOOSED_ITEM(this.isChooseList)
				this.sellerMessage = '';
				this.userStormList.forEach(p => {
						p.ttp=0
				})
				this.count = this.isChooseList.length
			},
			cleanBind() {
				this.bindItemList = [];
			},
			//成功时弹窗
			 open2(message) {
				 let tip=message
				this.$message({
				  message: tip,
				  type: 'success'
				});
			  },
			  //失败时弹窗
			  open3(message) {
				  let tip=message
				this.$message({
				  message: tip,
				  type: 'warning'
				});
			  },
			  tarCurrent(item){
				  this.tragetList=[]
				  this.userStormList.forEach(p => {
					if(p.checked) {
						this.tragetList.push(p)
					}
				  })
				 
				  console.log('选中',this.tragetList)
			  }
		}
	}
</script>

<style scoped>
	.stroeGoods .demo-table-expand {
		font-size: 0;
	}

	.stroeGoods .demo-table-expand label {
		width: 120px;
		color: #99a9bf;
	}

	.stroeGoods .demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.stroeGoods {
		flex: 1;
		/* padding: 60px 0 0 221px; */

		
	}

	.stroeGoods .el-dialog__body {
		padding-top: 0px;
	}

	.stroeGoods .list-item {
		justify-content: space-around;
		align-items: center;
		margin: 5px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
		background-color: #fff;
	}

	.stroeGoods .list-variation {
		justify-content: space-around;
		align-items: center;
	}
	
	.goods-title-desc-box{
		margin-right: 20px;
		width: 350px;
		overflow-wrap: break-word;
	}

	.stroeGoods .item-view {
		position: relative;
		display: flex;
		justify-content: space-around;
		align-items: center;
		border-bottom: 1px solid #E0E0E0;
		box-sizing: border-box;
		padding: 10px 0;
		/* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1); */
	}
	
	.goods-title-desc-wrapper{
		display: flex;
	}

	.stroeGoods .variation-list {
		justify-content: space-around;
		align-items: center;
	}

	.stroeGoods .el-collapse-item__content {
		padding: 0rem;
	}

	.stroeGoods .goods-pic {
		width: 80px;
		height: 80px;
		position: relative;
	}

	.stroeGoods .fixPic{
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		background: #eee;
		cursor: pointer;
		font-size: 12px;
		text-align: center;
		
	}
	
	.stroeGoods .oook{
		font-size: 20px;
		padding: 0 5px;
	}
	
	.my-goods-data{
		margin-bottom: 50px;
	}

	.stroeGoods .el-dialog__body {
		padding-bottom: 0px !important;
	}

	img {
		width: 100%;
	}
	
	.outPsku{
		height: 50px;
		line-height: 50px;
		/* border-bottom: 1px solid #E3E3E3; */
		font-size: 18px;
		font-weight: bold;
		padding-left: 15px;
		display: flex;
		justify-content: space-between;
	}
	
	.stroeGoods .yihdf{
		display: flex;
		
	}
	
	.stroeGoods .allChosee{
		padding-left: 20px;
	}

	.stroeGoods .el-collapse-item__header {

		float: right;
	}

/* 	.stroeGoods .goods-desc {
		display: flex;
		margin-left: 10px;
	} */
	.chekbox{
		position: absolute;
		top: 15px;
		left: 15px;
	}

	.stroeGoods .goods-item {
		
		width: 200px;
		margin: 0px 10px;
		color: #00193A;
	}
	.stroeGoods .goods-btn {
		display: inline-block;
		margin: 7px 10px;
	}
	

	.stroeGoods .goods-title {
		width: 500px;
		color: red;
	}

	.stroeGoods .mygoods-title,
	.query-list {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin: 5px 0;
		padding: 10px 0 5px 0;
		
	}

	.stroeGoods .shop-choose {
		display: inline-block;
		margin-right: 15px;
	}

	.stroeGoods .create {
		position: relative;
		margin-right: 30px;
	}
	.stroeGoods .xinzhen{
		float: right;
	}

	.stroeGoods .cirlle {
		position: absolute;
		top: -15px;
		left: -13px;
		display: block;
		width: 30px;
		height: 30px;
		background-color: red;
		border-radius: 50%;
		text-align: center;
		line-height: 30px;
		color: #fff;
	}
	.storeGoods .goods-title-desc{
		display: flex;
		flex-direction: column;
		min-width: 200px;
	}
	.stroeGoods  .mygoods-list-nodata{
		text-align: center;
		margin: 100px;
	}
	.stroeGoods .Pager{
		position: fixed;
		bottom: 0;
		left: 225px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
	}
	.stroeGoods .btn-wrapper{
		display: flex;
		flex-direction: column;
		margin: 0 8px;
	}
	.stroeGoods .btn-item-desc{
		
		width: 120px;
		margin: 5px 0;
		border: none !important;
	}
	
	.stroeGoods .query-list-bbc{
		display: flex;
		
	}
	
	.stroeGoods .header-top{
		
		margin-top:85px;
		background-color: #fff;
		z-index: 7;
		box-sizing: border-box;
		padding: 0 15px;
		/* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1); */
	}
	
	.stroeGoods .mygoods-list{
		margin-top: 35px;
	}
	
	 .stroeGoods .quit-box{
		display: flex;
		justify-content: space-between;
	}
	
	.quit-wrapper-item{
		font-size: 18px;
		width: 50%;
		text-align: center;
	}
	
	.quit-wapper{
		display: flex;
		justify-content: space-between;
		
	}
	
	.ttp-uu{
		text-align: right;
		box-sizing: border-box;
		padding: 10px;
		width: 100%;
	}
	
	.stroeGoods .query-list-tcp{
		display: flex;
		align-items: center;
		padding: 0 0 10px 0;
	}

	
	.visiableMessage_desc{
		line-height: 30px;
	}
	
	.bbp{
		margin-left: 20px;
		
	}
	
	.el-icon-edit{
		color: #007EE5;
		font-size: 16px;
		cursor: pointer;
		margin-left: 20px;
	}

</style>
